import { render, staticRenderFns } from "./RealTimeTaskPage.vue?vue&type=template&id=5b08f75b&scoped=true&"
import script from "./RealTimeTaskPage.vue?vue&type=script&lang=js&"
export * from "./RealTimeTaskPage.vue?vue&type=script&lang=js&"
import style0 from "./RealTimeTaskPage.vue?vue&type=style&index=0&id=5b08f75b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08f75b",
  null
  
)

export default component.exports